import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { businessLocations, locationLabel, logoutUser } from "../../actions/authActions";

const URLWatcher = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const storedBusinessId = localStorage.getItem("business_id");
    const storedLocationId = localStorage.getItem("location_id");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const business_id = params.get("business_id");
        const location_id = params.get("location_id");

        if (storedBusinessId) {
            dispatch(businessLocations(storedBusinessId));
            dispatch(locationLabel(storedBusinessId, storedLocationId));
        }

        if (
            (business_id && business_id !== storedBusinessId) ||
            (location_id && location_id !== storedLocationId)
        ) {
            localStorage.setItem("business_id", business_id);
            localStorage.setItem("location_id", location_id);
            dispatch(logoutUser());
        }
    }, [location.search, storedBusinessId]);

    return null;
};

export default URLWatcher;
